import React from 'react';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';

import playIcon from 'assets/images/heroCta.svg';

import styles from './CarouselButton.module.scss';

interface ButtonProps {
  children: React.ReactNode;
  className?: string | null;
  hasInitialFocus?: boolean;
  focusId?: string | number | null;
  onClick?: () => void;
  onFocusSet?: (value: boolean) => void;
  ttsText: string;
  showPlayIcon?: boolean;
  size?: string | null;
}

const Button = ({
  children,
  className = null,
  hasInitialFocus = false,
  focusId = null,
  onClick = () => {},
  onFocusSet = () => {},
  ttsText,
  showPlayIcon = true,
  ...rest
}: ButtonProps) => {
  return (
    <Selectable
      onSelect={onClick}
      hasInitialFocus={hasInitialFocus}
      focusId={focusId}
      onFocusSet={onFocusSet}
      ttsText={ttsText}
      render={({ hasFocus }) => (
        <button
          type="button"
          className={classNames(
            styles.button,
            className,
            hasFocus ? styles.focused : styles.unfocused,
          )}
          onClick={onClick}
          {...rest}
        >
          {showPlayIcon && <img src={playIcon} alt="" />} {children}
        </button>
      )}
    />
  );
};

export default React.memo(Button);
